import { render, staticRenderFns } from "./BasicDetailsUpdate.vue?vue&type=template&id=61b46eff"
import script from "./BasicDetailsUpdate.vue?vue&type=script&lang=js"
export * from "./BasicDetailsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports